<template>
  <el-menu default-active="2" :collapse="collapsed" collapse-transition router :default-active="$route.path" unique-opened class="el-menu-vertical-demo" background-color="#334157" text-color="#fff" active-text-color="#ffd04b">
  <el-menu-item index="/home/Home">
    <i style="font-size:30px" class="iconfont" :class="'icon-zhuye'"></i>
  </el-menu-item>
  <el-submenu v-for="menu in allmenu" :key="menu.menuid" :index="menu.menuname">
      <template slot="title">
        <i class="iconfont" :class="menu.icon"></i>
        <span>{{menu.menuname}}</span>
      </template>
      <el-menu-item-group>
        <el-menu-item v-for="chmenu in menu.menus" :index="'/'+chmenu.url" :key="chmenu.menuid">
          <i class="iconfont" :class="chmenu.icon"></i>
          <span>{{chmenu.menuname}}</span>
        </el-menu-item>
      </el-menu-item-group>
    </el-submenu>
  </el-menu>
</template>
<script>
import { menu,getRole } from '../api/userMG'
export default {
  name: 'leftnav',
  data() {
    return {
      collapsed: true,
      menuObj: {
        dbName: 'menu',
        page:1,
        parent: [],
        children: []
      },
      roleObj: {
        roleName: JSON.parse(localStorage.getItem('userdata'))._source.authority,
        roleAuthorization : '',
        editUser: '',
        editTime: ''
      },
      allmenu: []
    }
  },
  // 创建完毕状态(里面是操作)
  created() {
    // 获取图形验证码
    let res = {
      success: true,
      data: [],
      msg: 'success'
    }
    // this.allmenu = res.data

    getRole(this.roleObj)
      .then(res => {
        this.menuObj.parent = res.data[0].menu[0];
        this.menuObj.children = res.data[0].menu[1];
        console.log(res,'^@@@@@@@@@@@@@@@@@@@@@@@@@^');
        if(res.code === 201){
          menu(this.menuObj)
            .then(res => {
              console.log(res)
              if (res.code === 201) {
                this.allmenu = res.data
              } else {
                this.$message.error('Menu failed to load, please try again later！')
                return false
              }
            })
            .catch(err => {
              this.$message.error('Menu failed to load, please try again later！')
            })
        }
      })
      .catch(err => {

      })

    // 监听
    this.$root.Bus.$on('toggle', value => {
      this.collapsed = !value
    })
  }
}
</script>
<style>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 240px;
  min-height: 400px;
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
  text-align: left;
}
.el-menu-item-group__title {
  padding: 0px;
}
.el-menu-bg {
  background-color: #1f2d3d !important;
}
.el-menu {
  border: none;
}
.logobox {
  height: 40px;
  line-height: 40px;
  color: #9d9d9d;
  font-size: 20px;
  text-align: center;
  padding: 20px 0px;
}
.logoimg {
  height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/leftnav.vue